import XIcon from 'feather-icons/dist/icons/x.svg?raw';
import ArrowLeftIcon from 'feather-icons/dist/icons/arrow-left.svg?raw';
import PhoneIcon from 'feather-icons/dist/icons/phone.svg?raw';
import ChevronDownIcon from 'feather-icons/dist/icons/chevron-down.svg?raw';
import MailIcon from 'feather-icons/dist/icons/mail.svg?raw';
import UserIcon from 'feather-icons/dist/icons/user.svg?raw';
import MapPinIcon from 'feather-icons/dist/icons/map-pin.svg?raw';

const icons = {
  x: XIcon,
  'arrow-left': ArrowLeftIcon,
  phone: PhoneIcon,
  'chevron-down': ChevronDownIcon,
  mail: MailIcon,
  user: UserIcon,
  'map-pin': MapPinIcon,
};

export const initIcons = () => {
  document.querySelectorAll('[data-feather-icon]').forEach((el) => {
    const iconName = el.getAttribute('data-feather-icon');
    if (icons[iconName]) {
      el.outerHTML = icons[iconName].replace('<svg', '<svg aria-hidden');
    }
  });
};
